<template>
  <div>
    <!-- AppHeaderNew -->
    <AppHeaderNew />

    <section class="pages-banner">
      <div class="container text-center banner-box h-100">
        <h1>FAQs</h1>
      </div>
    </section>

    <div class="container inner-page-box faq-page-box">
      <div class="container breadcrumb-box">
          <p><router-link :to="{name: 'home'}">Home</router-link> > FAQs</p>
      </div>
      <h3>FAQs</h3>
      
    <div id="accordion">

      <!-- Card Item -->
      <div class="card">
        <div class="card-header" id="headingOne1">
          <h5 class="mb-0"><button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne1" aria-expanded="true" aria-controls="collapseOne1">How to download Amejpay app on your Smartphone?</button></h5>
        </div>
        <div id="collapseOne1" class="collapse show" aria-labelledby="headingOne1" data-parent="#accordion">
          <div class="card-body">It is very simple and easy to download on your smart phone on both IOS and Anroaid. You can simply open your IOS or Playstore  and type Amejpay.</div>
        </div>
      </div>

      <!-- Card Item -->
      <div class="card">
        <div class="card-header" id="headingOne2">
          <h5 class="mb-0"><button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne2" aria-expanded="true" aria-controls="collapseOne2">How to sign up and create an Amejpay account easily?</button></h5>
        </div>
        <div id="collapseOne2" class="collapse" aria-labelledby="headingOne2" data-parent="#accordion">
          <div class="card-body">
              <strong>For the signing up</strong>
              <ol type="a">
                <li>Open amejpay app or go to www.amejpay.com</li> 
                <li>click on sign up button and fill your details as asked or simply you can sign up through facebook.</li> 
                <li>You can also sign up via Phone number or email through verification codes.</li> 
                <li>After sign up you can simply provide your details and create your account.</li> 
                <li>After  creating account wait for the email confirmation for the approval.</li> 
                <li>After the approval you will get email confirmation along with amejpay account.</li>
              </ol> 
          </div>
        </div>
      </div>

      <!-- Card Item -->
      <div class="card">
        <div class="card-header" id="headingOne3">
          <h5 class="mb-0"><button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne3" aria-expanded="true" aria-controls="collapseOne3">Where can I use Amejpay? Is it available in my country?</button></h5>
        </div>
        <div id="collapseOne3" class="collapse" aria-labelledby="headingOne3" data-parent="#accordion">
          <div class="card-body">You can use amejpay for payment gateway for your businesses,  money transfer, utilities payments, wallet to wallet transfer. It will show on your app available or not depending upon your country.</div>
        </div>
      </div>

      <!-- Card Item -->
      <div class="card">
        <div class="card-header" id="headingOne4">
          <h5 class="mb-0"><button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne4" aria-expanded="true" aria-controls="collapseOne4">How to use Amejpay?</button></h5>
        </div>
        <div id="collapseOne4" class="collapse" aria-labelledby="headingOne4" data-parent="#accordion">
          <div class="card-body">
            <ol type="a">
                <li>Open amejpay app or on website.</li>
                <li>log in to your account.</li>
                <li>Select the service you wished to use for.</li>
            </ol>
          </div>
        </div>
      </div>

      <!-- Card Item -->
      <div class="card">
        <div class="card-header" id="headingOne5">
          <h5 class="mb-0"><button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne5" aria-expanded="true" aria-controls="collapseOne5">How to load funds in Amejpay account?</button></h5>
        </div>
        <div id="collapseOne5" class="collapse" aria-labelledby="headingOne5" data-parent="#accordion">
          <div class="card-body">
            <strong>Loading fund is very easy and fast. </strong>
            <ol type="a">
              <li>Open an account in amejpay app or website. </li>
              <li>Sign up and create account. </li>
              <li>Connect you bank account or you can also load money through visa, master and  debit cards.</li>
            </ol>
          </div>
        </div>
      </div>

      <!-- Card Item -->
      <div class="card">
        <div class="card-header" id="headingOne6">
          <h5 class="mb-0"><button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne6" aria-expanded="true" aria-controls="collapseOne6">How much can I load in one day in my wallet? Is there any limit?</button></h5>
        </div>
        <div id="collapseOne6" class="collapse" aria-labelledby="headingOne6" data-parent="#accordion">
          <div class="card-body">You can load up to <strong>$1000</strong> for day.</div>
        </div>
      </div>

      <!-- Card Item -->
      <div class="card">
        <div class="card-header" id="headingOne7">
          <h5 class="mb-0"><button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne7" aria-expanded="true" aria-controls="collapseOne7">How can I transfer funds?</button></h5>
        </div>
        <div id="collapseOne7" class="collapse" aria-labelledby="headingOne7" data-parent="#accordion">
          <div class="card-body">You can transfer directly wallet to wallet or via your direct bank to wallet  ( make sure your account is linked with your  bank account).</div>
        </div>
      </div>

      <!-- Card Item -->
      <div class="card">
        <div class="card-header" id="headingOne8">
          <h5 class="mb-0"><button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne8" aria-expanded="true" aria-controls="collapseOne8">Does other both the parties need to have amejpay inorder to make transfer?</button></h5>
        </div>
        <div id="collapseOne8" class="collapse" aria-labelledby="headingOne8" data-parent="#accordion">
          <div class="card-body">Yes both the parties must have Amejpay wallet to make direct transfer.</div>
        </div>
      </div>

      <!-- Card Item -->
      <div class="card">
        <div class="card-header" id="headingOne9">
          <h5 class="mb-0"><button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne9" aria-expanded="true" aria-controls="collapseOne9">Can amejpay be used as saving account ?</button></h5>
        </div>
        <div id="collapseOne9" class="collapse" aria-labelledby="headingOne9" data-parent="#accordion">
          <div class="card-body">Yes, amejpay is your digital bank where you can save and earn intrest as well.</div>
        </div>
      </div>

      <!-- Card Item -->
      <div class="card">
        <div class="card-header" id="headingOne10">
          <h5 class="mb-0"><button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne10" aria-expanded="true" aria-controls="collapseOne10">How much interest can I get?</button></h5>
        </div>
        <div id="collapseOne10" class="collapse" aria-labelledby="headingOne10" data-parent="#accordion">
          <div class="card-body">For the minimum saving of $100 for a year or more you can get 10% annual interest.</div>
        </div>
      </div>

      <!-- Card Item -->
      <div class="card">
        <div class="card-header" id="headingOne11">
          <h5 class="mb-0"><button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne11" aria-expanded="true" aria-controls="collapseOne11">Is there any other earning opportunity beside interest?</button></h5>
        </div>
        <div id="collapseOne11" class="collapse" aria-labelledby="headingOne11" data-parent="#accordion">
          <div class="card-body">Yes, you can earn amej coin by referring to your friends later you can convert amej coin into cash.</div>
        </div>
      </div>

      <!-- Card Item -->
      <div class="card">
        <div class="card-header" id="headingOne12">
          <h5 class="mb-0"><button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne12" aria-expanded="true" aria-controls="collapseOne12">Is there any transactions fee?</button></h5>
        </div>
        <div id="collapseOne12" class="collapse" aria-labelledby="headingOne2" data-parent="#accordion">
          <div class="card-body">Yes</div>
        </div>
      </div>

      <!-- Card Item -->
      <div class="card">
        <div class="card-header" id="headingOne13">
          <h5 class="mb-0"><button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne13" aria-expanded="true" aria-controls="collapseOne13">How do I load via cards?</button></h5>
        </div>
        <div id="collapseOne13" class="collapse" aria-labelledby="headingOne13" data-parent="#accordion">
          <div class="card-body">You can follow the guide lines in the App, Fill the  details one by one as being asked in the app.</div>
        </div>
      </div>

      <!-- Card Item -->
      <div class="card">
        <div class="card-header" id="headingOne14">
          <h5 class="mb-0"><button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne14" aria-expanded="true" aria-controls="collapseOne14">What is OTP? How can I generat OTP?</button></h5>
        </div>
        <div id="collapseOne14" class="collapse" aria-labelledby="headingOne14" data-parent="#accordion">
          <div class="card-body">A one time password that is valid for one logging session or one transaction which will be send via email or message on your phone.  You can simply generate by providing email or phone whichever you wished to be send OTP.</div>
        </div>
      </div>

      <!-- Card Item -->
      <div class="card">
        <div class="card-header" id="headingOne15">
          <h5 class="mb-0"><button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne15" aria-expanded="true" aria-controls="collapseOne15">Why didn't I receive OTP?</button></h5>
        </div>
        <div id="collapseOne15" class="collapse" aria-labelledby="headingOne15" data-parent="#accordion">
          <div class="card-body">You must have put wrong email or phone number, sometimes there might be also a technical malfunction.</div>
        </div>
      </div>

      <!-- Card Item -->
      <div class="card">
        <div class="card-header" id="headingOne16">
          <h5 class="mb-0"><button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne16" aria-expanded="true" aria-controls="collapseOne16">How do I get to know if someone has requested me for funds?</button></h5>
        </div>
        <div id="collapseOne16" class="collapse" aria-labelledby="headingOne16" data-parent="#accordion">
          <div class="card-body">You will get notification on your device . You will receive email or you can check on your account notification section.</div>
        </div>
      </div>

  </div>
      
  </div>

    <!-- FooterNew -->
    <AppFooterNew />
  </div>
</template>

<script type="text/javascript">
import AppHeaderNew from "../reuseable_components/HeaderNew";
import AppFooterNew from "../reuseable_components/FooterNew";

export default {
  name: "faqNew",
  components: {
    AppHeaderNew,
    AppFooterNew,
  },
  data() {
    return {
      //
    };
  },
};
</script>

<style type="text/css" scoped>
.faq-page-box #accordion .card .card-header .btn-link{
  text-align: left;
  float: left;
  font-weight: 500;
}
</style>